import { configureStore } from '@reduxjs/toolkit'
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query'
import { api } from './api'
import createPropertyReducer from './slices/createPropertySlice'
import propertySearchReducer from './slices/propertySearchSlice'
import googleApiReducer from './slices/googleApiSlice'
import messageSearchReducer from './slices/messageSearch'
import userReducer from './slices/userSlice'
import uiReducer from './slices/uiSlice'
import { toastMiddleware } from './toastMiddleware'

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    googleApi: googleApiReducer,
    createProperty: createPropertyReducer,
    propertySearch: propertySearchReducer,
    messageSearch: messageSearchReducer,
    user: userReducer,
    ui: uiReducer,
    [api.reducerPath]: api.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(api.middleware)
      .concat(toastMiddleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)
